/* eslint-disable */
import LazyLoad from "vanilla-lazyload";
import inView from "in-view";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import DrawSVGPlugin from "gsap/DrawSVGPlugin";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import Flickity from "flickity";

gsap.registerPlugin(DrawSVGPlugin, ScrollTrigger, ScrollToPlugin);

const HTML = document.querySelector("html");

class App {
  constructor() {
    this.lazyload = new LazyLoad({
      unobserve_entered: true,
      elements_selector: ".js-lazy",
      threshold: window.innerHeight * 0.8,
      thresholds: `${window.innerHeight * 0.8}px 0px`,
      // eslint-disable-next-line camelcase
      callback_enter: ($el) => {
        if ($el.classList.contains("js-lazy-error-placeholder")) {
          $el.lazyLoadPlaceholder = $el.src;
        } else if ($el.dataset.src == undefined) {
          const figure = $el.closest("figure");
          if (figure) figure.classList.add("img-is-loaded");
        }
      },
      callback_loaded: (el) => {
        const figure = el.closest("figure");
        if (figure) figure.classList.add("img-is-loaded");
      },
      // eslint-disable-next-line camelcase
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      },
    });

    // Anchors
    const anchors = document.querySelectorAll("a[href^='#']:not(.no-scroll)");
    if (anchors) {
      anchors.forEach((anchor) => {
        anchor.addEventListener("click", (e) => {
          e.preventDefault();
          const href = anchor.getAttribute("href");
          if (href == "#") return;
          const target = document.querySelector(href);
          if (target) {
            gsap.to(window, {
              scrollTo: target,
              ease: "expo.out",
              duration: 1,
            });
          }
        });
      });
    }

    /** TOGGLE MENU */
    const toggles = document.querySelectorAll(".toggle-menu");
    if (toggles) {
      toggles.forEach((toggle) => {
        toggle.addEventListener("click", (e) => {
          e.preventDefault();

          gsap.to(window, {
            scrollTo: 0,
            ease: "expo.out",
            duration: 0.4,
          });
          HTML.classList.toggle("open-menu");
        });
      });
    }

    this.scrollRotate();
    this.animationCircle();
    this.carousel();
    this.carouselCenter();
    this.accordion();
    this.popin();
    this.inViewport();
  }

  scrollRotate() {
    const elts = document.querySelectorAll(".scroll-rotate");

    if (elts && elts.length > 0) {
      elts.forEach((el) => {
        const turns = 1; // nombre de tours complets

        gsap.to(el, {
          rotation: 360 * turns,
          ease: "none",
          scrollTrigger: {
            trigger: el,
            start: "top bottom",
            end: `bottom top`,
            scrub: true,
            // markers: true,
          },
        });
      });
    }
  }

  animationCircle() {
    const elts = document.querySelectorAll(".animation-circle");

    if (elts) {
      elts.forEach((el) => {
        const pin = el.querySelector(".pin");
        const circles = el.querySelector(".circles");

        if (circles) {
          ScrollTrigger.create({
            trigger: pin,
            pin: circles,
            start: "top top",
            end: "bottom bottom",
          });
        }

        const mask = el.querySelector("#maskCircle");
        gsap.set(mask, {
          drawSVG: "0%",
        });

        gsap.to(mask, {
          drawSVG: "100%",
          ease: "linear.none",
          scrollTrigger: {
            trigger: pin,
            scrub: true,
            start: "top+=5% top",
            // markers: true,
          },
        });
      });
    }
  }

  carousel() {
    const elts = document.querySelectorAll(".carousel");

    if (elts && elts.length > 0) {
      elts.forEach((el) => {
        new Flickity(el, {
          cellAlign: "left",
          contain: true,
          pageDots: false,
        });
      });
    }
  }

  accordion() {
    const elts = document.querySelectorAll(".accordion");

    if (elts && elts.length > 0) {
      elts.forEach((el) => {
        const items = el.querySelectorAll(".accordion-item");
        const contents = el.querySelectorAll(".accordion-content");
        const headers = el.querySelectorAll(".accordion-header");

        if (items && contents && headers) {
          headers.forEach((header, i) => {
            header.addEventListener("click", (e) => {
              e.preventDefault();

              items[i].classList.toggle("active");

              const isActive = items[i].classList.contains("active");

              gsap.to(contents[i], {
                height: isActive ? contents[i].children[0].offsetHeight : "0px",
                autoAlpha: isActive ? 1 : 0,
                duration: 0.3,
                ease: "circ.inOut",
              });
            });
          });
        }
      });
    }
  }

  carouselCenter() {
    const elts = document.querySelectorAll(".carousel-center");

    if (elts && elts.length > 0) {
      elts.forEach((el) => {
        new Flickity(el, {
          wrapAround: true,
          pageDots: false,
          autoPlay: el.dataset.flickityAutoplay != undefined ? parseFloat(el.dataset.flickityAutoplay) : false,
        });
      });
    }
  }

  popin() {
    const elts = document.querySelectorAll("[data-popin]");
    if (elts && elts.length > 0) {
      elts.forEach((el) => {
        const target = document.querySelector(`#${el.dataset.popin}`);

        if (target) {
          const close = target.querySelector(".trigger-close");
          if (close) {
            close.addEventListener("click", (e) => {
              e.preventDefault();
              target.classList.remove("open");
            });
          }

          el.addEventListener("click", (e) => {
            e.preventDefault();
            target.classList.add("open");
          });

          target.addEventListener("click", (e) => {
            if (
              target.classList.contains("open") &&
              !e.target.classList.contains(".popin .content") &&
              !e.target.closest(".popin .content")
            ) {
              target.classList.remove("open");
            }
          });
        }
      });
    }
  }

  inViewport() {
    // In viewport
    inView.offset({
      bottom: window.innerHeight * 0.1,
    });
    inView(".js-reveal:not(.is-visible)")
      .on("enter", function (elt) {
        elt.dispatchEvent(new Event("inview"));
        elt.classList.add("is-visible");
        elt.classList.remove("not-visible");

        const video = elt.querySelector("video");

        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay == "true") ||
          (video && video.dataset.autoplay == "true")
        ) {
          const v = video || elt;
          const playPromise = v.play();
          if (playPromise !== null) {
            playPromise.catch(() => {
              v.play();
            });
          }
        }
      })
      .on("exit", function (elt) {
        const video = elt.querySelector("video");
        if (
          (elt.tagName == "VIDEO" && elt.dataset.autoplay != "") ||
          (video && video.dataset.autoplay != "")
        ) {
          const v = video || elt;
          v.pause();
        }

        elt.dispatchEvent(new Event("outview"));
        elt.classList.add("not-visible");
      });
  }
}

window.addEventListener("DOMContentLoaded", () => {
  new App();
});
